/**
 * English: Resolved org_id + station_id for chat WebSocket payloads (DWH-scoped).
 * Thai: org_id และ station_id ที่ resolve แล้วสำหรับส่งแชท
 */
import { useMemo } from 'react';
import { useAuth } from '../context/AuthContext';
import { useStation } from '../context/StationContext';
import { orgSlugFromBrowserPath } from '../config/publicPath';
import { resolveChatOrgId } from '../utils/resolveChatOrgId';

export function useChatOrgContext(): { orgId: string; stationId: string } {
  const { userOrgName, selectedOrgName } = useAuth();
  const { stations, activeStationId } = useStation();

  return useMemo(() => {
    const stationId = activeStationId.trim();
    const activeStation = stations.find((s) => s.id === stationId);
    const stationOrgName = String(
      (activeStation as { org_name?: string } | undefined)?.org_name ?? '',
    ).trim();
    const orgId = resolveChatOrgId({
      userOrgName: selectedOrgName || userOrgName,
      activeStationId: stationId,
      stationOrgName,
      pathOrgSlug: orgSlugFromBrowserPath(),
    });
    return { orgId, stationId };
  }, [stations, activeStationId, userOrgName, selectedOrgName]);
}
